import Api from '../apiWithStatus';
import ApiConstants from '../ApiConstants';
import connectAPI from '../connectApi';
import newAPI from '../new-api';
import { CONNECT_API_BASE_URL,API_URL } from '../../env';

const getPatientDetails = (params, token) => {

    return Api(`${ApiConstants.PATIENT_DETAILS}/${params}`, null, 'get', token);
};
function getDocFromAlias(params, token) {
    return connectAPI(ApiConstants.GET_DOC_FROM_ALIAS, params, 'post', token);
}
function addUserToWaitingRoom(params, token) {
    return connectAPI(ApiConstants.ADD_USER_TO_WAITING, params, 'post', token);
}
function callEndByPatientAPI(params, token) {
    return connectAPI(ApiConstants.CALL_END_BY_PATIENT, params, 'post', token);
}
function checkRoomStatus(params, token) {
    return connectAPI(ApiConstants.CHECK_ROOM_STATUS, params, 'post', token);
}
function disconnectReasonAPI(params, token) {
    return connectAPI(ApiConstants.DISCONNECT_REASON, params, 'post', token);
}
function generateCallIdByPatientId(params, token) {
    return connectAPI(
        ApiConstants.GENERATE_CALL_ID_BY_PATIENT,
        params,
        'post',
        token,
    );
}
function getOpentokRoomKeys(params, token) {
    return connectAPI(ApiConstants.GET_OPEN_TOK_ROOM_KEYS, params, 'post', token);
}
function invalidateAPI(params, token) {
    return newAPI(ApiConstants.INVALIDATE, params, 'post', token);
}

function notifyProvider(params, token) {
    return newAPI(ApiConstants.NOTIFY_PROVIDER, params, 'post', token);
}
function updateRoomStatus(params, token) {
    return connectAPI(ApiConstants.UPDATE_ROOM_STATUS, params, 'post', token);
}
function providerSettingsAPI(room, token) {
    return connectAPI(
        `${ApiConstants.PROVIDER_SETTINGS}/${room}`,
        null,
        'get',
        token,
    );
}

const uploadMedication = (params, token) => {
    return connectAPI(
        ApiConstants.UPLOAD_MEDICATIONS,
        params,
        'post',
        token,
        CONNECT_API_BASE_URL,
    );
};
function searchAllergy(params, token) {
    return connectAPI(
        ApiConstants.ALLERGY_SEARCH,
        params,
        'post',
        token,
        API_URL,
        true,
        true
    );
}
const searchMedication = (params, token) => {
    return connectAPI(
        ApiConstants.MEDICATION_SEARCH,
        params,
        'post',
        token,
        API_URL,
        true,
        true
    );
};
export {
    getPatientDetails,
    getDocFromAlias,
    addUserToWaitingRoom,
    callEndByPatientAPI,
    checkRoomStatus,
    disconnectReasonAPI,
    generateCallIdByPatientId,
    getOpentokRoomKeys,
    notifyProvider,
    invalidateAPI,
    updateRoomStatus,
    providerSettingsAPI,
    uploadMedication,
    searchAllergy,
    searchMedication
}